import { Button } from "@omni/ui/components/Button/button.component";
import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useDropdownContext } from "@/components/General/Dropdown/context/dropdown.context";

type ToggleProps = {
    className?: string;
    children: ReactNode;
} & Omit<ButtonComponentProps, "ref" | "tabIndex" | "className">;

export const Toggle = ({ className, children, ...props }: ToggleProps) => {
    const { getToggleProps, setToggleRef } = useDropdownContext();

    return (
        <Button
            {...getToggleProps()}
            {...props}
            ref={setToggleRef}
            tabIndex={0}
            className={cn("tw:flex tw:gap-0", className)}
        >
            {children}
        </Button>
    );
};
